/* __next_internal_client_entry_do_not_use__ Default auto */ import { jsx as _jsx } from "react/jsx-runtime";
// Global
import { useMemo } from 'react';
import { withStandardComponentWrapper } from 'helpers/HOC';
import { getTestProps } from 'lib/testing/utils';
import { useRealPathName } from 'lib/hooks/useRealPathName';
import ReportsAndInsightsListSearchWidget from 'widgets/ReportsAndInsightsList';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
import useIsEditing from 'lib/hooks/useIsEditing';
const ReportsAndInsightsList = (props)=>{
    const isEditing = useIsEditing();
    const path = useRealPathName();
    const id = props?.params?.RenderingIdentifier;
    const sourceId = useMemo(()=>process.env.NEXT_PUBLIC_SEARCH_NEWS_SOURCE_ID ? [
            process.env.NEXT_PUBLIC_SEARCH_NEWS_SOURCE_ID
        ] : undefined, []);
    return /*#__PURE__*/ _jsx("section", {
        id: id ? id : 'reports-and-insights-list',
        "data-component": "authorable/shared/search/reportsandinsightslist",
        ...editingHydrationProps(isEditing),
        ...getTestProps(`component-search-result-${props?.rendering?.uid}`),
        children: /*#__PURE__*/ _jsx(ReportsAndInsightsListSearchWidget, {
            rfkId: "rfkid_reports_insights",
            sources: sourceId
        }, path)
    });
};
export const Default = withStandardComponentWrapper(ReportsAndInsightsList);
